import {Rectangle as Base} from '../../../../lib/objects/Rectangle';

/**
 * Base class for drawable rectangle. Must be inherited. Children must implement "paint(ctx, offsetX, offsetY, drawing.w, drawing.h)" method.
 */
export class BaseRectangle extends Base {
  constructor (x, y, w, h, options) {
    super(x, y, w, h);
    this._options = options;
  }

  draw (surface) {
    const drawing = this.clone().normalize();
    const offsetX = drawing.x + surface.position.x;
    const offsetY = drawing.y + surface.position.y;
    const ctx = surface.ctx;

    // We can skip the drawing if the element has moved off the screen:
    if (offsetX > surface.width || offsetY > surface.height || +drawing.w < 0 || offsetY + drawing.h < 0) {
      return;
    }

    this.paint(ctx, offsetX, offsetY, drawing.w, drawing.h);
  }
}



// WEBPACK FOOTER //
// ./src/uScope/js/extensions/snapshot/drawing/shapes/BaseRectangle.js